module.exports = __webpack_public_path__ + "plus-2021jump/images/main_signboard.278c630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main_signboard.png
// module id = eq0b
// module chunks = 0